import axios from 'axios'
import jwtDecode from 'jwt-decode'
const qs = require('qs')
const CryptoJS = require('crypto-js')
import { env } from '@/env'
let serverUrl = env.VUE_APP_REDIRECT_URL
let secretKey = env.VUE_APP_SECRET_KEY
let serverauthUrl = env.VUE_APP_REDIRECT_AUTH_URL
console.log('****', serverauthUrl)

export const state = {
  authToken: getSavedState('auth.authToken'),
  currentUser: null,
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
  SET_CURRENT_USER_AUTHTOKEN(state, newValue) {
    state.authToken = newValue
    saveState('auth.authToken', newValue)
    setDefaultAuthHeaders(state)
  },
  CLEAR_USER_DETAILS(state, newValue) {
    state.authToken = newValue
    state.currentUser = newValue
    localStorage.removeItem('auth.currentUser')
    localStorage.removeItem('refresh_token')

    localStorage.removeItem('auth.authToken')
    localStorage.removeItem('buildingLink.authToken')
  },
  CLEAR_STORAGE(state, newValue) {
    state.authToken = newValue
    state.currentUser = newValue
    localStorage.removeItem('auth.currentUser')
    localStorage.removeItem('auth.authToken')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('popup')
    // sessionStorage.clear()
    localStorage.clear()
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.authToken
  },
  userDetails(state) {
    return !!state.currentUser
  },
  userDetailsForNavigation(state) {
    // return getSavedState('auth.currentUser')
    return getSavedState('auth.authToken')
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validateToken')
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { Email, Password } = {}) {
    return true
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('CLEAR_STORAGE', null)
    console.log('LOGOUT')
  },
  // Clear token
  cleanToken({ commit }) {
    commit('CLEAR_USER_DETAILS', null)
    console.log('LOGOUT')
  },
  // This API implemented in backend due cors error
  getAuthToken({ commit, dispatch, getters }, { code } = {}) {
    var param = qs.stringify({
      grant_type: 'authorization_code',
      code: code,
      // redirect_uri: 'http://localhost:8080/authlogin/',
      redirect_uri: serverauthUrl,
      // client_id: 'bldev-5ecd52d41184843060abaa5c',
      // client_secret: 'vHWhJiKNxCRfdfghjksfb8jrwQttJ',
      client_id: 'bldev-5d726b34f6c6fc11a08307de',
      client_secret: '5bc0a299ea75eddc482513ce',
    })
    return axios({
      method: 'post',
      url: 'https://auth.buildinglink.com/connect/token',
      // url: 'https://auth-main-dev.blkqa.com/connect/token',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: param,
    })
      .then((response) => {
        console.log(
          'getAuthToken -> response.access_token',
          response.data.access_token
        )

        localStorage.setItem(
          'buildingLink.authToken',
          response.data.access_token
        )
        localStorage.setItem('refresh_token', response.data.refresh_token)
        commit(
          'SET_CURRENT_USER_AUTHTOKEN',
          jwtDecode(response.data.access_token)
        )

        // return response.data.result
        return jwtDecode(response.data.access_token)
      })
      .catch((error) => {
        console.log('TCL: getAuthToken -> error', error)
        throw error
      })
  },
  // To get refresh token
  async getRefreshAuthToken({ commit, dispatch, state }) {
    dispatch('validateToken')
  },

  validateToken({ commit, dispatch, state }) {
    return new Promise(async (resolve, reject) => {
      if (!state.authToken || !getSavedState('auth.authToken')) {
        dispatch('cleanToken')
        window.localStorage.clear()
        return resolve('success')
      }
      console.log('ValidateToken Called')
      var param = qs.stringify({
        grant_type: 'refresh_token',
        refresh_token: localStorage.getItem('refresh_token'),
        redirect_uri: serverUrl,
        // client_id: 'bldev-5ecd52d41184843060abaa5c',
        // client_secret: 'vHWhJiKNxCRfdfghjksfb8jrwQttJ',
        client_id: 'bldev-5d726b34f6c6fc11a08307de',
        client_secret: '5bc0a299ea75eddc482513ce',
      })

      axios({
        method: 'post',
        url: 'https://auth.buildinglink.com/connect/token',
        // url: 'https://auth-main-dev.blkqa.com/connect/token',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: param,
      })
        .then((response) => {
          console.log('getAuthToken -> response')

          localStorage.setItem(
            'buildingLink.authToken',
            response.data.access_token
          )
          localStorage.setItem('refresh_token', response.data.refresh_token)
          commit(
            'SET_CURRENT_USER_AUTHTOKEN',
            jwtDecode(response.data.access_token)
          )

          // return response.data.result
          return resolve('success')
        })
        .catch((error) => {
          console.log('validateToken -> error', error)
          dispatch('cleanToken')
          return reject(error)
        })
    })
  },
  validate({ commit, state, dispatch }) {
    if (!state.authToken || !getSavedState('auth.authToken')) {
      console.log('validate -> !state.authToken Validate ACTION LINE 244 ')
      // window.sessionStorage.clear()
      dispatch('cleanToken')
      // window.localStorage.clear()
      return Promise.resolve(null)
    }
    var userInformation = getSavedState('auth.currentUser')
    return userInformation
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  try {
    const bytes = CryptoJS.AES.decrypt(
      window.localStorage.getItem(key)
        ? window.localStorage.getItem(key).toString()
        : '',
      secretKey
    )
    const serializedState = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))

    if (serializedState === null) {
      return undefined
    }
    return serializedState
  } catch (err) {
    // console.log(`Error while Load state for key ${key} ${err}`)
    return undefined
  }
  // return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  if (!state) {
    window.localStorage.setItem(key, null)
    return
  }
  try {
    const serializedState = JSON.stringify(state)
    var ciphertext = CryptoJS.AES.encrypt(serializedState, secretKey)
    // localStorage.setItem('state', ciphertext)
    window.localStorage.setItem(key, ciphertext)
  } catch (err) {
    console.log('Error while saving state' + err)
    // TODO: Logs
  }
}

function setDefaultAuthHeaders(state) {
  // axios.defaults.headers.common.Authorization = state.authToken
  //   ? state.authToken.access_token
  //   : ''
  const EAuth = localStorage.getItem('buildingLink.authToken')
  // console.log('setDefaultAuthHeaders -> EAuth', EAuth)
  axios.defaults.headers.common.Authorization = state.authToken
    ? 'Bearer ' + EAuth
    : ''
}
